// extracted by mini-css-extract-plugin
export default {"subTitle":"collectPeriod_subTitle__ImLMC","dataWrapper":"collectPeriod_dataWrapper__h1i-L"};